<p>{{ 'NO_FUNDS' | translate }}</p>
